import { Button, MagellanPopup } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiWarning } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { Container } from 'components/atoms';

interface IPopupBanLabelWarningProps {
  trigger?: JSX.Element;
  disabledTrigger?: boolean;
  name?: string;
  onBan?: (actions: PopupActions, withdrawAllProducts: boolean) => void;
  banLoading?: boolean;
  transI18nKey?: string;
  isClear?: boolean;
}

const PopupBanLabelWarning = ({
  trigger,
  disabledTrigger,
  name = '',
  onBan,
  banLoading,
  transI18nKey,
  isClear = true,
}: IPopupBanLabelWarningProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);
  const [withdrawAllProducts, setWithdrawAllProducts] = useState<boolean>(false);

  const handleBan = () => {
    if (onBan && popupRef.current) {
      onBan(popupRef.current, withdrawAllProducts);
    }
  };

  return (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={trigger}>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col max-w-96 text-center gap-4'>
          <p className='opacity-55'>
            <Trans
              i18nKey={transI18nKey ?? 'popup.ban-popup'}
              values={{ name: name }}
              components={{ strong: <strong /> }}
            />
          </p>
          <div className='flex justify-center'>
            <FormInput.Select
              label={t('label.withdraw-all-content')}
              isClearable={false}
              name='withdrawAllProducts'
              options={[
                { label: t('input.option.yes'), value: true },
                { label: t('input.option.no'), value: false },
              ]}
              displayMode={false}
              value={{ label: t('input.option.no'), value: false }}
              onChange={(value) => setWithdrawAllProducts(Boolean(value.value))}
            />
          </div>
          <p className='opacity-55'>{t(`popup.question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.cancel`)} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.remove}
            onClick={handleBan}
            isLoading={banLoading}>
            <Button.Text text={t(`popup.approve`)} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default PopupBanLabelWarning;
